(function (AUFHAUSEN) {
    'use strict';
    AUFHAUSEN = AUFHAUSEN || {};

    document.addEventListener('DOMContentLoaded', function () {
         // Init pictures already in the page
        [].forEach.call( document.querySelectorAll( '.js-lazy-picture' ), function( picture ) {
            new AUFHAUSEN.LazyPictureElement( picture );
        } );

        new AUFHAUSEN.Menu();
    });
}(window.AUFHAUSEN));